/*=========================================================================================
  File Name: modulePartnerGetters.js
  Description: Partner Module Getters
==========================================================================================*/


export default {
    queriedPrograms: state => state.programs.filter((program) => {
      let isItemOfCurrentFilter = false

      if(
           state.programFilter === 'all'
        || state.programFilter === 'consider' && program.state == 0
        || state.programFilter === 'approved' && program.state == 1
        || state.programFilter === 'blocked' && program.state == 2
        // || task.tags.includes(state.programFilter)

      ) { isItemOfCurrentFilter = true }

      return isItemOfCurrentFilter && (program.name.toLowerCase().includes(state.programSearchQuery.toLowerCase()) || program.descr.toLowerCase().includes(state.programSearchQuery.toLowerCase()))
    }),
    getProgram: state => programId => state.programs.find((program) => program.ppid == programId),
    getPartner: state => state.partner,
    getPartneri: state => partnerId => state.partners.find((partner) => partner.partid == partnerId),
    getPartners: state => state.partners,
}
